/*
  总值： amount
  预计使用寿命(月): serviceLifeMonth 总寿命（月）
  预计净残值率: netSalvage  需要扣减掉的值，就是残掉的值
  已折旧月份： depreciatedYear

*/
export function depreciation (form) {
  if (form.serviceLifeMonth <= form.depreciatedYear) {
    form.avgDepreciation = 0;
    form.cumulativeDepreciation = 0;
    form.assetNetSalvage = 0;
  }

  switch (form.depreciationId) {
    /**
     * 
  ``1、平均年限法：
      月折旧率 = (1 - 预计净残值率)÷ 预计使用寿命(月)× 100%      amount:100    serviceLifeMonth:6   已使用：4     剩余率：40%
      月折旧额 = 固定资产原价× 月折旧率
     */
    case 1:
      let ratio = 0;
      if (form.serviceLifeMonth) {
        ratio = (100 - form.netSalvage) / form.serviceLifeMonth / 100
      }

      if (form.amount) {
        // form.avgDepreciation = (form.amount * ratio).toFixed(4) * 1
        // // console.log(form.avgDepreciation, '月平均折旧额')
        // form.cumulativeDepreciation = (form.avgDepreciation * form.depreciatedYear).toFixed(4) * 1
        // // console.log(form.cumulativeDepreciation, '累计折旧额', form.depreciatedYear)
        // form.assetNetSalvage = (form.amount - form.avgDepreciation * form.depreciatedYear).toFixed(4) * 1
        // // console.log(form.assetNetSalvage, '净残值')

        // 2022-3-1 修改
        // 月折旧额 = （总金额 - 预计净残值）/ 预计使用寿命(月)
        var yue = (form.amount - form.salvage) / form.serviceLifeMonth
        // 月折旧率 = 月折旧额 / 总金额
        var yueRatio = yue / form.amount
        // 月平均折旧额  = 总金额 * 月折旧率
        form.avgDepreciation = form.amount * yueRatio
        // 已折旧年份
        // 累计折旧额 = 累计折旧额 +月平均折旧额
        form.cumulativeDepreciation = (form.avgDepreciation * form.depreciatedYear).toFixed(4) * 1
        // 资产净残值 = 总金额 - 累计折旧额
        form.assetNetSalvage = form.amount - form.cumulativeDepreciation
      }
      break;
    case 2:
      /** 
    2、工作量法：  
      单位工作量折旧额 =【固定资产原价*（1-预计净残值率）】/预计总工作量 
      某项固定资产月折旧额 = 该项固定资产当月工作量*单位工作量折旧额        该项固定资产当月工作量
       */
      if (form.amount && form.totalWorkload && form.serviceLifeMonth) {
        let singleAmount = (form.amount * (1 - form.netSalvage)) / form.totalWorkload // 单位工作量折旧额
        let perMonthWorkload = form.totalWorkload / form.serviceLifeMonth;   // 每月工作量
        form.avgDepreciation = (perMonthWorkload * singleAmount).toFixed(4) * 1
        console.log(form.avgDepreciation, '月平均折旧额')
      }
      form.cumulativeDepreciation = (form.avgDepreciation * form.depreciatedYear).toFixed(4) * 1
      console.log(form.cumulativeDepreciation, '累计折旧额', form.depreciatedYear)
      form.assetNetSalvage = (form.amount - form.avgDepreciation * form.depreciatedYear).toFixed(4) * 1
      console.log(form.assetNetSalvage, '净残值')
      break;
    case 3:
      doubleBalanceSubtraction(form);
      break;
    case 4:
      yearSumAmount(form)
      break;
    default:
      return;
  }
}


/**
 * 双倍余额递减法
 * @param {Object} form 表单数据
 */
let doubleBalanceSubtraction = function (form) {
  /**
  3、双倍余额递减法：
      年折旧率=【2/预计使用年限】*100%            预计使用年限：总的寿命
      年折旧额=每年年初固定资产账面净值*年折旧率         每年年初固定资产账面净值： 递归计算，从第一年开始算
      月折旧率=年折旧率/12 
      月折旧额=年折旧额/12       
       */
  if (!form.amount || !form.serviceLifeMonth) {
    return
  }
  let totalYears = form.serviceLifeMonth / 12;
  // 必须是整年
  if (totalYears % 1 != 0) {
    return;
  }
  let yearRatio = 2 / totalYears  // 年折旧率
  let year = Math.floor(form.depreciatedYear / 12)

  // 不足2年的先获取前面几年折旧之后剩余的资产账面净值
  let amount = form.amount
  if (year > 0) {
    for (let i = 1; i <= totalYears - 2; i++) {
      amount = amount - amount * yearRatio
      if (i == year) {
        break;
      }
    }
  }

  if (form.serviceLifeMonth - form.depreciatedYear < 24) {
    amount = amount - form.salvage
    // 剩余每月折旧额
    let p = amount / 24

    form.avgDepreciation = (p).toFixed(4) * 1  // 月折旧额
    form.assetNetSalvage = (amount - amount * (24 - form.serviceLifeMonth + form.depreciatedYear) / 24 + form.salvage).toFixed(4) * 1
    form.cumulativeDepreciation = (form.amount - form.assetNetSalvage).toFixed(4) * 1

  }
  else {
    let month = form.depreciatedYear % 12
    console.log("amount", amount)
    // 剩余年限大于2年
    form.avgDepreciation = (amount * yearRatio / 12).toFixed(4) * 1  // 月折旧额
    // 本年已折旧
    let thisYearAmount = (amount * yearRatio * month / 12).toFixed(4) * 1
    form.assetNetSalvage = (amount - thisYearAmount).toFixed(4) * 1
    form.cumulativeDepreciation = (form.amount - form.assetNetSalvage).toFixed(4) * 1

    // 2022-3-1 修改
    // 最后两年的月折旧额 = （固定资产账面净值 - 预计净残值）/ 24
    // form.avgDepreciation = (amount - form.salvage) / 24
    // console.log("最后两年的月折旧额", form.avgDepreciation)
    // form.cumulativeDepreciation = (form.avgDepreciation * form.depreciatedYear).toFixed(4) * 1
    // form.assetNetSalvage = form.amount - form.cumulativeDepreciation

    // 本年已折旧

  }
}

/**
 * 年数总额法
 * @param {Object} form 
 */
let yearSumAmount = function (form) {
  /**
  4、年数总额法：
      年折旧率=【尚可使用年限/预计使用寿命的年数总和】*100%          尚可使用年限(剩余寿命)   预计使用寿命的年数总和：2年：1+2，3年：1+2+3
      月折旧率= 年折旧率/12 
      月折旧额=（固定资产原价-预计净残值）*月折旧率     总寿命
   */

  // 预计使用年限
  let totalYears = form.serviceLifeMonth / 12;
  // 必须是整年
  if (totalYears % 1 != 0) {
    return;
  }
  // 年数总和
  let yearSum = 0;
  for (let i = 1; i <= totalYears; i++) {
    yearSum += i;
  }

  // 尚可使用年限
  let year = Math.ceil((form.serviceLifeMonth - form.depreciatedYear) / 12);
  let yearRatio = year / yearSum
  form.avgDepreciation = ((form.amount - form.salvage) * yearRatio / 12).toFixed(4) * 1 // 月折旧额


  let month = form.depreciatedYear % 12
  // 获取历史已折旧金额
  if (year == totalYears) {
    form.assetNetSalvage = (form.amount - form.avgDepreciation * month).toFixed(4) * 1
    form.cumulativeDepreciation = (form.amount - form.assetNetSalvage).toFixed(4) * 1
  }
  else {
    let amounted = 0;
    for (let i = 0; i < totalYears - year; i++) {
      amounted += (form.amount - form.salvage) * (totalYears - i) / yearSum
    }

    form.assetNetSalvage = (form.amount - amounted - form.avgDepreciation * month).toFixed(4) * 1
    form.cumulativeDepreciation = (form.amount - form.assetNetSalvage).toFixed(4) * 1
  }

}

